// @flow
export const GetIntegrationApplications = "GET_INTEGRATION_APPLICATIONS";
export const GetIntegrationApplicationsSuccess = "GET_INTEGRATION_APPLICATIONS_SUCCESS";
export const GetIntegrationApplicationsError = "GET_INTEGRATION_APPLICATIONS_ERROR";

export const CreateIntegrationApplication = "CREATE_INTEGRATION_APPLICATION";
export const CreateIntegrationApplicationSuccess = "CREATE_INTEGRATION_APPLICATION_SUCCESS";
export const CreateIntegrationApplicationError = "CREATE_INTEGRATION_APPLICATION_ERROR";

export const UpdateIntegrationApplication = "UPDATE_INTEGRATION_APPLICATION";
export const UpdateIntegrationApplicationSuccess = "UPDATE_INTEGRATION_APPLICATION_SUCCESS";
export const UpdateIntegrationApplicationError = "UPDATE_INTEGRATION_APPLICATION_ERROR";

export const DeleteIntegrationApplication = "DELETE_INTEGRATION_APPLICATION";
export const DeleteIntegrationApplicationSuccess = "DELETE_INTEGRATION_APPLICATION_SUCCESS";
export const DeleteIntegrationApplicationError = "DELETE_INTEGRATION_APPLICATION_ERROR";

export const GetIntegrationApplicationDetails = "GET_INTEGRATION_APPLICATION_DETAILS";
export const GetIntegrationApplicationDetailsSuccess =
  "GET_INTEGRATION_APPLICATION_DETAILS_SUCCESS";
export const GetIntegrationApplicationDetailsError = "GET_INTEGRATION_APPLICATION_DETAILS_ERROR";

export const GetIntegrationSecretKey = "GET_INTEGRATION_SECRET_KEY";
export const GetIntegrationSecretKeySuccess = "GET_INTEGRATION_SECRET_KEY_SUCCESS";
export const GetIntegrationSecretKeyError = "GET_INTEGRATION_SECRET_KEY_ERROR";

export const GenerateIntegrationSecretKey = "GENERATE_INTEGRATION_SECRET_KEY";
export const GenerateIntegrationSecretKeySuccess = "GENERATE_INTEGRATION_SECRET_KEY_SUCCESS";
export const GenerateIntegrationSecretKeyError = "GENERATE_INTEGRATION_SECRET_KEY_ERROR";

export const GetIntegrationOfflineToken = "GET_INTEGRATION_OFFLINE_TOKEN";
export const GetIntegrationOfflineTokenSuccess = "GET_INTEGRATION_OFFLINE_TOKEN_SUCCESS";
export const GetIntegrationOfflineTokenFailed = "GET_INTEGRATION_OFFLINE_TOKEN_FAILED";

export const GenerateIntegrationOfflineToken = "GENERATE_INTEGRATION_OFFLINE_TOKEN";
export const GenerateIntegrationOfflineTokenSuccess = "GENERATE_INTEGRATION_OFFLINE_TOKEN_SUCCESS";
export const GenerateIntegrationOfflineTokenError = "GENERATE_INTEGRATION_OFFLINE_TOKEN_ERROR";

export const ToggleIntegrationApplicationFormModal = "TOGGLE_INTEGRATION_APPLICATION_FORM_MODAL";
export const ToggleIntegrationDeleteModal = "TOGGLE_INTEGRATION_DELETE_MODAL";
export const ToggleIntegrationTokenModal = "TOGGLE_INTEGRATION_TOKEN_MODAL";
